import { map } from 'rxjs/operators';
import { MusicSettingsService } from './../../../services/music-settings/music-settings.service';
import { SubSink } from 'subsink';
import { ModalController, ToastController } from '@ionic/angular';
import { PlatformService } from './../../../services/platform/platform.service';
import { FormGroup, FormBuilder, NgForm, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-music-settings',
  templateUrl: './music-settings.page.html',
  styleUrls: ['./music-settings.page.scss'],
})
export class MusicSettingsPage implements OnInit {
  static_genre: any;
  genre: string;
  subscription = new SubSink();
  isMobileDevice: boolean;
  musicForm: FormGroup;
  isCreate: boolean = true;
  isCreateGenre: boolean = true;

  showSpinner: boolean = false;

  isAudio: boolean = true;
  is_not_audio_message = '';

  response_message: string = '';
  hasResponseError: boolean = false;

  music_1_preview: string = null;
  music_2_preview: string = null;
  music_3_preview: string = null;

  dropdownList: any[] = [];
  selectedItems: any[] = [];
  dropdownSettings: IDropdownSettings = {};

  isMusicEmpty: boolean;

  constructor(
    private fb: FormBuilder,
    private platform: PlatformService,
    private modalCtrl: ModalController,
    private toast: ToastController,
    private musicService: MusicSettingsService
  ) {
    this.isMobileDevice = this.platform.isMobile();
  }

  ngOnInit() {
    this.readyMusicForm();
    this.setDropdownSettings();
    this.getGenre();
    this.getMusicInfoData();
  }

  ionViewWillLeave(){
    this.subscription.unsubscribe();
  }

  readyMusicForm() {
    this.musicForm = this.fb.group({
      user_genres: [[], Validators.required],
      music_1: File,
      music_2: File,
      music_3: File,
    });
  }

  get user_genres() {
    return this.musicForm.get('user_genres');
  }

  get music_1() {
    return this.musicForm.get('music_1');
  }

  get music_2() {
    return this.musicForm.get('music_2');
  }

  get music_3() {
    return this.musicForm.get('music_3');
  }

  setDropdownSettings() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
  }

  readyFormData(res: any) {
    res.forEach((element) => {
      if (element.music_type === 'music_1') {
        this.music_1_preview = element?.music_name ? element.music_name : null;
      } else if (element.music_type === 'music_2') {
        this.music_2_preview = element?.music_name ? element.music_name : null;
      } else if (element.music_type === 'music_3') {
        this.music_3_preview = element?.music_name ? element.music_name : null;
      }
    });

    if (res?.status === undefined) {
      this.isCreate = false;
    }

  }


  readyGenreFormData(res: any) {
    // console.log("my genre data ==> ",res[0].user_genres)
    this.musicForm.patchValue({
      user_genres: res[0].user_genres.map((element)=>{
        return {
          item_text: element.genre.genre_name,
          item_id: Number.parseInt(element.genre_id)
        };
      })
    })

    this.musicForm.markAsPristine();

    if (res.length !== 0) {
      this.isCreateGenre = false;
    }

    // console.log("Genre data res -------> ",res)
  }

  getGenre() {
    this.subscription.sink = this.musicService.getGenre().subscribe(
      (genre: any[]) => {
        this.static_genre = genre['data'];
        this.static_genre.forEach((genre) => {
          let item = {
            item_id: Number.parseInt(genre.id),
            item_text: genre.genre_name,
          };
          this.dropdownList.push(item);
        });
        this.dropdownList = Object.assign([], this.dropdownList);
      },
      (error) => console.log(error)
    );
  }

  uploadAudio(event: any, identifier: string) {
    if (
      event.target.files &&
      event.target.files[0] &&
      event.target.files[0].type.includes('audio/')
    ) {
      const reader = new FileReader();

      reader.onload = (_event: any) => {
        if (identifier === 'music_1') {
          this.music_1_preview = event.srcElement.files[0].name;
        } else if (identifier === 'music_2') {
          this.music_2_preview = event.srcElement.files[0].name;
        } else if (identifier === 'music_3') {
          this.music_3_preview = event.srcElement.files[0].name;
        }

        this.isAudio= true;

        this.musicForm.get(`${identifier}`)?.setValue(event.target.files[0]);
        // console.log(
        //   `${identifier} data --------> `,
        //   this.musicForm.get(`${identifier}`).value
        // );
        if (identifier === 'music_1') {
          this.music_1.markAsDirty();
        } else if (identifier === 'music_2') {
          this.music_2.markAsDirty();
        } else if (identifier === 'music_3') {
          this.music_3.markAsDirty();
        }
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      if (identifier === 'music_1') {
        this.music_1_preview = null;
      } else if (identifier === 'music_2') {
        this.music_2_preview = null;
      } else if (identifier === 'music_3') {
        this.music_3_preview = null;
      }
      this.musicForm.get(`${identifier}`)?.setValue(null);
      if (event.target.files[0] !== undefined) {
        this.isAudio = false;
        this.is_not_audio_message = "Only Audio files can be uploaded";
      }
    }
  }

  getUserGenreData() {
    this.subscription.sink = this.musicService.getUserGenre().subscribe(
      (res: any) => {
        let stored_genres = res.data;
        this.readyGenreFormData(stored_genres);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getMusicInfoData() {
    this.getUserGenreData();
    this.subscription.sink = this.musicService.getMusicInfo().subscribe(
      (res_musicInfo: any) => {
        // console.log('stored music info --------------> ', res_musicInfo);
        this.readyFormData(res_musicInfo);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  submitGenreData(genreData, musicFormInfo) {
    // console.log("create genre payload ==> ",genreData);
    if (this.isCreateGenre) {
      this.subscription.sink = this.musicService
        .createUserGenre(genreData)
        .subscribe(
          (res: any) => {
            this.isCreateGenre = false;
            if (!this.isMusicEmpty) {
              delete musicFormInfo['user_genres'];
              this.addMusic(musicFormInfo);
            } else {
              this.showSpinner = false;
              this.response_message = res.message;
              this.presentSuccessToast(this.response_message);
            }

            // console.log('create genre response ----------> ', res);
          },
          (err: any) => {
            console.log('Error -------> ', err);
          }
        );
    } else {
      // console.log('latest music info -----------> ', genreData);
      this.subscription.sink = this.musicService
        .updateUserGenre(genreData)
        .subscribe(
          (res: any) => {
            if (!this.isMusicEmpty) {
              delete musicFormInfo['user_genres'];
              this.addMusic(musicFormInfo);
            } else {
              this.showSpinner = false;
              this.response_message = res.message;
              this.presentSuccessToast(this.response_message);
            }
            // console.log('update genre response ----------> ', res);
          },
          (err: any) => {
            console.log('Error -------> ', err);
          }
        );
    }
  }

  updateMusic() {
    this.showSpinner = true;
    let musicFormInfo = this.musicForm.value;
    if (musicFormInfo.music_1?.size === undefined && musicFormInfo.music_2?.size === undefined && musicFormInfo.music_3?.size === undefined) {
      this.isMusicEmpty = true;
    } else {
      this.isMusicEmpty = false;
    }
    console.log("music form info start ==> ",musicFormInfo.music_1?.size);
    let new_genres: any = [];
    musicFormInfo.user_genres.forEach(element => {
      new_genres.push(element.item_id);
    });

    let genreData = {
      user_genres: new_genres
    }

    // console.log('Genre data -----------> ', genreData);

    console.log(genreData);
    this.submitGenreData(genreData, musicFormInfo);

  }

  addMusic(musicFormInfo) {
    var musicInfo: FormData = new FormData();
    musicInfo.append("music_1", musicFormInfo?.music_1);
    musicInfo.append("music_2", musicFormInfo?.music_2);
    musicInfo.append("music_3", musicFormInfo?.music_3);
    console.log('Music info -------------> ', musicInfo);
    if (this.isCreate) {
      this.subscription.sink = this.musicService
        .createMusicInfo(musicInfo)
        .subscribe(
          (res: any) => {
            this.isCreate = false;
            this.showSpinner = false;
            // console.log('create music response ----------> ', res);
            this.hasResponseError = false;
            this.response_message = res.message;
            this.presentSuccessToast(this.response_message);
          },
          (err: any) => {
            this.showSpinner = false;
            // console.log('Error -------> ', err);
            this.hasResponseError = true;
            this.response_message = "An error occurred adding your Music, please try again later.";
            this.presentErrorToast(this.response_message);
          }
        );
    }
    else {
      // console.log('latest music info -----------> ', musicInfo);
      this.subscription.sink = this.musicService
        .updateMusicInfo(musicInfo)
        .subscribe(
          (res: any) => {
            this.showSpinner = false;
            // console.log('update music response ----------> ', res);
            this.hasResponseError = false;
            this.response_message = res.message;
            this.presentSuccessToast(this.response_message);
          },
          (err: any) => {
            this.showSpinner = false;
            // console.log('Error -------> ', err);
            this.hasResponseError = true;
            this.response_message = "An error occurred updating your Music, please try again later.";
            this.presentErrorToast(this.response_message);
          }
        );
    }

  }

  async presentSuccessToast(res_message) {
    const toast = await this.toast.create({
      header: 'Success',
      color: 'success',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  closeModal() {
    return this.modalCtrl.dismiss();
  }
}
